import React, { useEffect } from 'react';
import { Button, Alert, Row, Col, Form } from 'react-bootstrap';
import { Redirect, Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

// actions
import { resetAuth, loginUser } from '../../redux/actions';

// store
import { RootState, AppDispatch } from '../../redux/store';

// components
import { VerticalForm, FormInput } from '../../components/';

import AuthLayout from './AuthLayout';

interface LocationState {
    from?: Location;
}

interface UserData {
    email: string;
    senha: string;
}

/* bottom links */
const BottomLink = () => {
    const { t } = useTranslation();

    return (
        <Row className="mt-3">
            <Col className="text-center">
                <p>
                    <Link to={'/esqueceu-senha'} className="text-white-50 ms-1">
                        {t('Esqueceu sua senha?')}
                    </Link>
                </p>
            </Col>
        </Row>
    );
};

const Login = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const { user, userLoggedIn, loading, error } = useSelector((state: RootState) => ({
        user: state.Auth.user,
        loading: state.Auth.loading,
        error: state.Auth.error,
        userLoggedIn: state.Auth.userLoggedIn,
    }));

    useEffect(() => {
        dispatch(resetAuth());
    }, [dispatch]);

    /*
    form validation schema
    */
    const schemaResolver = yupResolver(
        yup.object().shape({
            email: yup.string().required(t('Por favor insira o nome de usuário')),
            senha: yup.string().required(t('Por favor insira a senha')),
        })
    );

    /*
    handle form submission
    */
    const onSubmit = (formData: UserData) => {
        dispatch(loginUser(formData['email'], formData['senha']));
    };

    const location = useLocation<LocationState>();
    const redirectUrl = location.state && location.state.from ? location.state.from.pathname : '/';

    return (
        <>
            {(userLoggedIn || user) && <Redirect to={redirectUrl}></Redirect>}

            <AuthLayout
                helpText={t('Digite o seu e-mail e senha para acessar a plataforma Yes Play.')}
                bottomLinks={<BottomLink />}
            >
                {error && (
                    <Alert variant="danger" className="my-2">
                        {error?.response?.data?.error}
                    </Alert>
                )}

                <VerticalForm<UserData>
                    onSubmit={onSubmit}
                    resolver={schemaResolver}
                >
                    <FormInput
                        label={t('E-mail')}
                        type="text"
                        name="email"
                        placeholder="Digite o seu e-mail"
                        containerClass={'mb-3'}
                    />
                    <FormInput
                        label={t('Senha')}
                        type="password"
                        name="senha"
                        placeholder="Digite sua senha"
                        containerClass={'mb-3'}
                    ></FormInput>

                    <Form.Check type="checkbox" id="default-checkbox1" label="Lembrar-me" className='mt-3 mb-3' checked/>

                    <div className="text-center d-grid">
                        <Button variant="danger" type="submit" disabled={loading}>
                            {t('Entrar')}
                        </Button>
                    </div>

                </VerticalForm>
            </AuthLayout>
        </>
    );
};

export default Login;
